import { render, staticRenderFns } from "./StatisticTableClass.vue?vue&type=template&id=7511f826&scoped=true"
import script from "./StatisticTableClass.vue?vue&type=script&lang=js"
export * from "./StatisticTableClass.vue?vue&type=script&lang=js"
import style0 from "./StatisticTableClass.vue?vue&type=style&index=0&id=7511f826&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7511f826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7511f826')) {
      api.createRecord('7511f826', component.options)
    } else {
      api.reload('7511f826', component.options)
    }
    module.hot.accept("./StatisticTableClass.vue?vue&type=template&id=7511f826&scoped=true", function () {
      api.rerender('7511f826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionStatistics/Class/StatisticTableClass.vue"
export default component.exports